import { View, Text } from "@react-pdf/renderer";
import { useMemo } from "react";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

export function Options({ activeAbnNotice }: { activeAbnNotice: IAbnNotice }) {
  const processedAbnSelectionOptions = useMemo(() => {
    return activeAbnNotice?.documentSnapshot?.availableOptions;
  }, [activeAbnNotice?.documentSnapshot?.availableOptions]);

  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 12,
        gap: 3,
      }}
    >
      <Text
        style={{
          ...styles.bodyText,
          fontFamily: "Helvetica-Bold",
        }}
      >
        PLEASE INITIAL NEXT TO THE OPTION YOU CHOOSE:
      </Text>
      {processedAbnSelectionOptions?.map((option, index) => (
        <View
          key={option.value}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            marginBottom: 4,
          }}
        >
          <View style={{ display: "flex", flexDirection: "row" }}>
            <View
              style={{
                width: "30px",
                borderBottom: "1px solid black",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {activeAbnNotice?.documentSnapshot?.selectedOption?.value ===
              option.value ? (
                <Text
                  style={{
                    ...styles.bodyText,
                    marginBottom: 0,
                  }}
                >
                  X
                </Text>
              ) : (
                ""
              )}
            </View>
            <Text
              style={{
                ...styles.bodyText,
                fontFamily: "Helvetica-Bold",
                marginBottom: 0,
              }}
            >
              Option {index + 1}: {option?.title || ""}
            </Text>
          </View>
          <Text style={{ ...styles.bodyText, marginBottom: 4 }}>
            {option.label}
          </Text>
        </View>
      ))}
    </View>
  );
}
